define(["require", "exports", "./context", "./jquery-plugins/draggable"], function (require, exports, context_1, draggable_1) {
    "use strict";
    exports.__esModule = true;
    function layoutSpinner($sel, box) {
        if (context_1["default"].isMobile() && draggable_1.isIOS) {
            return {
                focus: function () {
                    $sel.toggleClass('hidden', true);
                    box.scrollIntoView({ block: 'start' });
                },
                blur: function () {
                    $sel.toggleClass('hidden', false);
                }
            };
        }
        return {
            focus: function () { },
            blur: function () { }
        };
    }
    exports.layoutSpinner = layoutSpinner;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/selectSpinner.js
// module id = 57
// module chunks = 0